import actions from './actions';
import mutations from './mutations';

function cleanState () {
    return {
        busy: false,
        payments: [],
        pendingBills: [],
        pendingInvoices: [],
        sentInvoices: [],
        disposedInvoices: [],
        ignoredPayments: [],
        moreToFetch: true,
        lastSnapshot: null,
        bills: {},
        sent: {},
        listeners: []
    }
}

export default {
    namespaced: true,
  
    state: cleanState,

    getters: {
        pendingBillsPayments: (state) => Object.values(state.bills)
            .filter(bill => bill.payments.filter(p => p.fiscalStatus === 'pending').length)
            .sort((a, b) => a.openedOn && b.openedOn && b.openedOn.toDate() - a.openedOn.toDate()),
        ignoredBillPayments: (state) => Object.values(state.ignoredPayments)
            .sort((a, b) => a.openedOn && b.openedOn && b.openedOn.toDate() - a.openedOn.toDate()),
    },
  
    actions,

    mutations: {
        
        ...mutations,
        
        unregisterListeners (state, key) {
            if (key) {
                if (state.listeners[key])
                    state.listeners[key]();
            } else
                Object.values(state.listeners).forEach(unsubscribe => unsubscribe());
        },
        reset(state) {
            const clean = cleanState();
            Object.keys(state).forEach(key => state[key] = clean[key]);
        },
    }
}